module.exports = __webpack_public_path__ + "static/media/Sport_3.3af316b9.jpg";